import {gql} from "@apollo/client";

export const UPLOAD_IMAGE_MUTATION = gql`
  mutation ($file: Upload!) {
    uploadFile(file: $file)
  }
`;

export const UPDATE_MY_AGENCY = gql`
  mutation (
    $id: Int!
    $name: String
    $representative: String
    $documentNumber: String
    $expiresAt: DateTime
    $documents: [String!]
    $firstName: String
    $lastName: String
    $businessName: String
    $fiscalCode: String
    $vatNumber: String
    $address: String
    $houseNumber: String
    $postalCode: Int
    $province: String
    $email: String
    $pecEmail: String
    $sdiEmail: String
    $pecEmailAddress: String
    $documentTypeId: Int
    $companyTypeId: String
    $municipalityId: Int
    $regionId: Int
    $streetId: String
    $dylogType: String
  ) {
    updateMyAgency(
      options: {
        id: $id
        name: $name
        representative: $representative
        documentNumber: $documentNumber
        expiresAt: $expiresAt
        documents: $documents
        firstName: $firstName
        lastName: $lastName
        businessName: $businessName
        fiscalCode: $fiscalCode
        vatNumber: $vatNumber
        address: $address
        houseNumber: $houseNumber
        postalCode: $postalCode
        province: $province
        email: $email
        pecEmail: $pecEmail
        sdiEmail: $sdiEmail
        pecEmailAddress: $pecEmailAddress
        documentTypeId: $documentTypeId
        companyTypeId: $companyTypeId
        municipalityId: $municipalityId
        regionId: $regionId
        streetId: $streetId
        dylogType: $dylogType
      }
    ) {
      errors {
        message
      }
    }
  }
`;

export const UPDATE_MY_DETAIL = gql`
  mutation (
    $id: Int!
    $firstName: String!
    $lastName: String!
    $email: String!
    $mobileNumber: String
    $notifiedBy: [ReceiptEnumType!]!
    $password: String
    $repeatPassword: String
  ) {
    updateMyDetail(
      options: {
        id: $id
        firstName: $firstName
        lastName: $lastName
        email: $email
        mobileNumber: $mobileNumber
        notifiedBy: $notifiedBy
        password: $password
        repeatPassword: $repeatPassword
        acceptedTerms: true
      }
    ) {
      errors {
        message
      }
    }
  }
`;

export const UPDATE_STATUS_OF_UNREAD_ESTIMATE = gql`
  mutation ($id: Int!) {
    updateStatusOfUnreadEstimate(id: $id) {
      data {
        id
      }
    }
  }
`;
